
<div class="row">
    <div class="col-md-6">
        <div class="card">
            <div class="card-header">
              <div class="row">
                <table>
                  <thead>
                    <tr>
                      <th *ngFor="let letter of letters"><a (click)="onLetterClicked(letter)"> {{letter}} </a></th>
                    </tr>
                  </thead>
                </table>
              </div>
              <div class="row">
                    <div class="col-6">
                        <h5>Users</h5>
                    </div>
                    <div class="col-6">
                        <a class="fa fa-plus" aria-hidden="true" ngbToolTip="New User" href="/account/register"></a>
                    </div>
                </div>
            </div>
            <div class="card-block">
                <table class="table-hover">
                    <!--<table class="table-striped table-hover">-->
                    <tr>
                        <th>Logon</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Admin</th>
                        <th></th>
                        <!--<th></th>-->
                    </tr>
                    <tr *ngFor="let user of users"
                        (click)="onSelect(user)"
                        [class.selected]="selectedUser !== undefined && user.UserId == selectedUser.UserId">
                        <td>
                            <span *ngIf="!user.editable"> {{user.ShortName}} </span>
                            <input *ngIf="user.editable" type="text" [(ngModel)]="user.ShortName" class="form-control" />
                        </td>
                        <td>
                            <span *ngIf="!user.editable"> {{user.DisplayName}} </span>
                            <input *ngIf="user.editable" type="text" [(ngModel)]="user.DisplayName" class="form-control" />
                        </td>
                        <td>
                            <span *ngIf="!user.editable"> {{user.Email}} </span>
                            <input *ngIf="user.editable" type="email" [(ngModel)]="user.Email" class="form-control" /><!-- validate email -->
                        </td>
                        <td> <input type="checkbox" [checked]="user.IsAdmin" (change)="user.IsAdmin = !user.IsAdmin" [disabled]="!user.editable" /> </td>
                        <td>
                            <span class="fa fa-pencil" aria-hidden="true" *ngIf="!user.editable" (click)="toggleEditable(user)" ngbTooltip="Edit"></span>
                            <span class="fa fa-floppy-o" aria-hidden="true" *ngIf="user.editable" (click)="save(user)" ngbTooltip="Save"></span>
                        </td>
                        <!--<td> {{user.editable}} </td>-->
                    </tr>
                </table>
            </div>
        </div>
    </div>
    <div class="col-md-6">
      <div class="sticky">
        <div class="card">
          <div class="card-header">
            <div class="row">
              <h5>Sites</h5>
            </div>
          </div>
          <div class="card-block">
            <user-sites *ngIf="selectedUser"
                        [user]="selectedUser"
                        [sites]="selectedUser.SiteMembership">
            </user-sites>
          </div>
        </div>
      </div>
    </div>
</div>
